/* eslint-disable camelcase */
import ja_jp from './ja_jp';
import zh_cn from './zh_cn';
import en_us from './en_us';

const i18n = {
  en_us,
  ja_jp,
  zh_cn,
};

const { locale } = window.okGlobal;
const messages = i18n[locale.toLowerCase()];

function toLocale(key, values) {
  return messages[key].replace(/{(\w+)}/g, (match, group) => {
    return values[group];
  });
}

export { toLocale };
